import { Outlet } from "react-router-dom";

export function SubscriptionLayout() {
  return (
    <div className="min-h-screen max-w-md mx-auto flex flex-col">
      <main className="flex-1 pt-2 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
